var map = {
	"./admin-user": 4,
	"./admin-user.jpg": 4,
	"./businessCard": 5,
	"./businessCard.jpg": 5,
	"./fake/001": 6,
	"./fake/001.jpg": 6,
	"./fake/002": 7,
	"./fake/002.jpg": 7,
	"./fake/003": 8,
	"./fake/003.jpg": 8,
	"./fake/004": 9,
	"./fake/004.jpg": 9,
	"./fake/005": 10,
	"./fake/005.jpg": 10,
	"./fake/006": 11,
	"./fake/006.jpg": 11,
	"./fake/007": 12,
	"./fake/007.jpg": 12,
	"./fake/008": 13,
	"./fake/008.jpg": 13,
	"./favicon.ico": 31,
	"./logo": 14,
	"./logo.png": 14,
	"./qr-code-share": 15,
	"./qr-code-share.png": 15,
	"./share-icon": 16,
	"./share-icon-origin": 17,
	"./share-icon-origin.png": 17,
	"./share-icon.png": 16,
	"./video_page": 18,
	"./video_page.jpeg": 18,
	"./watermark": 19,
	"./watermark-origin": 20,
	"./watermark-origin.png": 20,
	"./watermark.png": 19
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30;